import { useQuery } from '@tanstack/react-query';
import { getTenantAthleteProgress, getTenantDirectoryOverview } from '../lib/tenantDirectory';
import type { TenantAthleteProgressResponse, TenantDirectoryOverviewResponse } from '../types';

export const tenantDirectoryKeys = {
  all: ['tenant-directory'] as const,
  overview: () => [...tenantDirectoryKeys.all, 'overview'] as const,
  athleteProgress: (athleteId: number | null) => [...tenantDirectoryKeys.all, 'athlete-progress', athleteId] as const,
};

export function useTenantDirectory(enabled: boolean = true) {
  const query = useQuery<TenantDirectoryOverviewResponse>({
    queryKey: tenantDirectoryKeys.overview(),
    queryFn: getTenantDirectoryOverview,
    staleTime: 30 * 1000,
    retry: false,
    enabled,
  });

  return {
    directory: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}

export function useTenantAthleteProgress(athleteId: number | null, enabled: boolean = true) {
  const query = useQuery<TenantAthleteProgressResponse>({
    queryKey: tenantDirectoryKeys.athleteProgress(athleteId),
    queryFn: () => getTenantAthleteProgress(athleteId as number),
    staleTime: 30 * 1000,
    retry: false,
    enabled: enabled && athleteId != null,
  });

  return {
    progress: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
